const rootActionPath = 'core/HowItWorks';

export const HOW_IT_WORKS_VIEW = `${rootActionPath}/VIEW`;
export const HOW_IT_WORKS_SLIDE_CHANGE = `${rootActionPath}/SLIDE/CHANGE`;
export const WATCH_HOW_IT_WORKS_VIEW = `${rootActionPath}/VIEW`;
